// removed by extract-text-webpack-plugin
module.exports = {"Text":"_2Bar_","dashboard-is-editing":"_3yZLY","text-card-textarea":"_3Y3LS","text-card-markdown":"_3mYr6"};


//////////////////
// WEBPACK FOOTER
// ./visualizations/visualizations/Text.css
// module id = 470
// module chunks = 3 4 5